<template>
<div class="containerWrapper">
  <Dialog :visible.sync="display" :modal="true">
    <template #header>
      <h3>Lägg till aktivitet</h3>
    </template>
    <ActivityWrapper v-if="order.data" :activity="activity" />
  </Dialog>
  <div class="container details">
    <div class="row">
      <div class="col-md-10">
        <h1>Order {{order.id}}</h1>
      </div>
      <div class="col-md-2 col">
        <p v-if="order.state != null" class="stateWrapper"><strong>Status: </strong><span :class="order.state">{{ order.state }}</span></p>
        <div v-if="order.version != undefined" class="versionWrapper">
          <p>
            <span v-if="order.data.truckVersion != undefined">
              <span v-if="order.version == order.data.truckVersion"><span class="inSync">I synk<i class="pi pi-check"></i> </span></span>
              <span v-else><span class="notInSync">Ej i synk<i class="pi pi-exclamation-triangle"></i></span></span>
            </span>
          </p>
        </div>
        <div v-if="order.data != null && order.data.accepted != null" class="acceptedWrapper">
          <p><strong>Accepterad av</strong></p>
          <ul>
            <li v-for="(acceptedObject, key) in order.data.accepted" :key="key">
              {{acceptedObject.driverName}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <TabView>
      <TabPanel header="Information">
          <div class="row">
            <form class="formGeneratorWithColumns feralcoOrderDetailsActiveWrapper">
              <vue-form-generator tag="div" :schema="activeSchema" :model="order.data" @model-updated="onModelUpdated" />
            </form>
          </div>
      </TabPanel>
      <TabPanel class="reportedPanel" header="Rapporterat" v-if="order.state === 'aktiv' || order.state === 'lastad' || order.state === 'sparad' || order.state === 'faktureras' || order.state === 'fakturerad' || order.state === 'avslutad'">
        <ActivityTable :activities="activities" :orderRow="order.data.orderRows[0]" :orderType="order.type" :customerPlaces="customerPlaces" :isOpen="true" :showTotal="false" />
      </TabPanel>
    </TabView>
  </div>
  <div v-if="isExternalUser == false" class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <SplitButton v-if="order.state !== 'makulerad' && order.state !== 'kopierad'" :disabled="!(order.data && order.data.fraktsedelNr)" label="Spara" :model="saveButtons" class="p-button-success" @click="onSave()" icon="pi pi-check" ></SplitButton>
        <Button v-else class="p-button-success" label="Spara" :disabled="!(order.data && order.data.fraktsedelNr)" @click="onSave()" icon="pi pi-check"></Button>
        <Button v-if="order.state !== 'makulerad'" label="Kopiera" class="p-button-success" @click="onCopy()" icon="pi pi-file" ></Button>
        <Button v-if="order.state === 'avslutad' && order.state !='fakturaredo'" label="Klar för fakturering" @click="onReadyForInvoice(order)"/>
        <Button v-if="order.state !== 'avslutad' && order.state!=='makulerad' && order.state !='fakturaredo'" label="Avsluta" @click="onFinished()"/>
        <Button v-if="order.state!=='makulerad'" label="Makulera" class="p-button-danger" @click="onDelete()"/>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
    <Toast :position="toastPosition" />
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Map from '@/components/Map/Map'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import moment from 'moment'
import { bus } from '../../main'
import SplitButton from 'primevue/splitbutton'
import ActivityTable from '@/components/Activities/ActivityTable'
export default {
  name: 'FeralcoInternOrderDetails',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    Toast,
    Map,
    Dialog,
    ActivityTable,
    Button,
    SplitButton,
    TabView,
    TabPanel,
    moment
  },
  data () {
    return {
      order: {},
      schema: {},
      activeSchema: {},
      customerName: '',
      mapArray: [],
      endCustomerName: '',
      dataArray: [],
      display: false,
      activity: '',
      activities: [],
      connectedOrders: [],
      drivers: null,
      isExternalUser: false,
      customerPlaces: [
        {id: '9998', name: 'Vetlanda', artnr: ''},
        {id: '9999', name: 'Sölvesborg', artnr: ''}
      ],
      saveButtons: [
        {
          label: 'Skicka till lastbil',
          icon: 'pi pi-user',
          command: () => {
            this.onReady()
          }
        }
      ],
      toastPosition: 'topright'
    }
  },
  props: {
    orderIdFromTab: null
  },
  async mounted () {
    this.checkExternalUser()
    let responseData = await this.getOrder()
    this.order = responseData.order
    if (this.order.data.orderRows) {
      this.activities = this.order.data.orderRows[0].actions
    } else {
      this.activities = []
    }
    this.schema = responseData.schema
    this.activeInputs()
    this.disabledInputs()
    this.getDrivers()
    this.getTrucks()
    this.getTrailers()
    this.getConnectedOrders()
  },
  created () {
    bus.$on('removedOrderRow', (id) => {
      this.order.data.orderRows = this.order.data.orderRows.filter(function (obj) {
        return obj.id !== id
      })
    })
    bus.$on('addedOrderRow', (orderRow) => {
      this.order.data.orderRows.push(orderRow)
    })
    bus.$on('addedActivity', (obj, id, activity) => {
      if (activity.name === 'Avslutad') {
        this.order.data.orderRows[0].endTime = activity.startTime
        this.order.data.orderRows[0].state = 'Avslutad'
      }
      this.currentOrder.data.orderRows[0].actions = obj
      this.display = false
    })
    bus.$on('addedTime', obj => {
      if (obj !== '' && obj !== null) {
        var splitTime = obj.split(':')
        if (splitTime[0] !== '' && splitTime[0].length < 2) {
          splitTime[0] = '0' + splitTime[0]
        }
        obj = splitTime[0] + ':' + splitTime[1]
        this.order.data.DecidedLoadingEndTime = obj
      }
    })
    bus.$on('changedActivitiesOrder', (obj, id) => {
      if (this.currentOrder.data.orderRows[0].id === id) {
        this.currentOrder.data.orderRows[0].actions = obj
      }
    })
  },
  watch: {
    order: function (newVal, oldVal) {
      this.currentOrder = newVal
    },
    schema: function (newVal, oldVal) {
      this.currentShema = newVal
    },
    '$route' (to, from) {
      this.init()
    }
  },
  methods: {
    async init () {
      let responseData = await this.getOrder()
      this.order = responseData.order
      if (this.order.data.orderRows) {
        this.activities = this.order.data.orderRows[0].actions
      } else {
        this.activities = []
      }
      this.schema = responseData.schema
      this.activeInputs()
      this.disabledInputs()
      this.getDrivers()
      this.getTrucks()
      this.getTrailers()
      if (this.order.state === 'aktiv' || this.order.state === 'lastad' || this.order.state === 'sparad') {
        this.getActiveTruckPosition()
      }
    },
    checkExternalUser () {
      if (localStorage.getItem('role') === 'Extern') {
        this.isExternalUser = true
      }
    },
    onModelUpdated (newVal, schema) {
      if (schema === 'driverLoading') {
        this.order.data.driverDelivering = newVal
        let driver = this.drivers.find(x => x.id === newVal)
        if (driver.truckId !== null) {
          this.order.data.truck = driver.truckId
        }
        if (driver.trailerId !== null) {
          this.order.data.trailer = driver.trailerId
        }
        this.checkPermission(driver)
      } else if (schema === 'driverDelivering' || schema === 'trailerDriverName') {
        let driver = this.drivers.find(x => x.id === newVal)
        this.checkPermission(driver)
      } else if (schema === 'connectedOrder') {
        if (newVal !== null && newVal.groupLoading !== '' && newVal.groupLoading !== '') {
          this.order.data.GroupLoading = newVal.groupLoading
        } else if (newVal == null) {
          this.order.data.GroupLoading = null
          this.order.data.connectedOrder = null
        } else {
          this.order.data.GroupLoading = 'HAGENSINTERN-' + this.order.id
        }
      } else if (schema === '') {

      }
    },
    async getOrder () {
      if (this.$props.orderIdFromTab === undefined) {
        let response = await this.$http.get('/api/orders/by-type/feralcoIntern/' + this.$route.params.id)
        return response.data
      } else {
        let response = await this.$http.get('/api/orders/by-type/feralcoIntern/' + this.$props.orderIdFromTab)
        return response.data
      }
    },
    getActiveTruckPosition () {
      this.$http
        .get('/api/objectdatasWithGPS/' + this.order.data.truck)
        .then(response => {
          let logData = '<div class="logData"><strong>Logg</strong><ul>'
          let truckName = ''
          let driverName = ''
          if (this.order.data.orderRows) {
            let orderRow = this.order.data.orderRows[0]
            truckName = this.order.data.orderRows[0].truckName
            driverName = this.order.data.orderRows[0].driverName
            for (var c = 0; c < orderRow.actions.length; c++) {
              var startTime = moment(orderRow.actions[c].startTime).format('MM-DD HH:mm')
              var endTime = ''
              if (orderRow.actions[c].endTime) {
                endTime = '<br/>' + moment(orderRow.actions[c].endTime).format('MM-DD HH:mm')
              }
              logData = logData + '<li><span>' + startTime + endTime + '</span><span>' + orderRow.actions[c].name + '</span></li>'
            }
            var activeState = orderRow.actions.slice(-1)[0].name
          }
          var destination = this.order.data.deliveryPlaces
          logData = logData + '</ul></div>'
          let Data = '<div class="mapInfoWrapper"><strong>' + truckName + '</strong><ul><li><span>Ordernr</span><span>' + this.order.id + '</span></li><li><span>Destination</span><span>' + destination + '</span></li><li><span>Chaufför</span><span>' + driverName + '</span></li></ul>' + logData + '</div>'
          var latestGpsLoc = response.data.GpsPositions.slice(-1)[0]
          let truckObj = { State: activeState, OrderType: this.order.type, Name: truckName, Driver: driverName, Order: this.order, OrderId: this.order.id, Destination: destination, Latitude: latestGpsLoc.lat, Longitude: latestGpsLoc.lon, Title: truckName, Data: Data }
          this.dataArray.push(truckObj)
        })
        .catch(error => console.log(error))
    },
    getConnectedOrders () {
      this.$http
        .get('/api/orders/get-active')
        .then(response => {
          this.connectedOrders = response.data
          var connectedOrdersSelect = this.activeSchema.groups[6].fields.find(field => field.model === 'connectedOrder')
          for (var i = 0; i < response.data.length; i++) {
            let groupLoading = ''
            if (response.data[i].data.GroupLoading !== undefined) {
              groupLoading = response.data[i].data.GroupLoading
            } else {
              groupLoading = ''
            }
            connectedOrdersSelect.values.push({id: {id: response.data[i].id, groupLoading: groupLoading}, name: response.data[i].data.SalesId + ' ' + response.data[i].data.DeliveryPlaceCity})
          }
        })
        .catch(error => console.log(error))
    },
    open () {
      this.display = true
    },
    onChange (event) {
      if (event.target.value) {
        this.activity = event.target.value
        this.display = true
      }
    },
    activeInputs () {
      this.activeSchema = Object.assign({}, this.schema)
      this.activeSchema.groups = this.activeSchema.groups.filter((c) => c.activeInDetails)
    },
    disabledInputs () {
      this.schema.groups = this.schema.groups.filter((c) => c.activeInDetails === false)
    },
    setLoadingPlace (loadingPlace) {
      var DecidedLoadingDate = this.activeSchema.groups[1].fields.find(field => field.model === 'DecidedLoadingDate')
      DecidedLoadingDate.loadingPlace = loadingPlace
    },
    getDrivers () {
      var driverLoadingSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'driverLoading')
      var driverDeliveringSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'driverDelivering')
      var trailerDriverDeliveringSelect = this.activeSchema.groups[5].fields.find(field => field.model === 'trailerDriverName')
      this.$http
        .get('/api/users/drivers')
        .then(response => {
          var users = response.data
          this.drivers = response.data
          for (var i = 0; i < users.length; i++) {
            if (users[i].permissionADRTank === 'Ja' && users[i].inActive !== 'Ja') {
              driverLoadingSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
              driverDeliveringSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
              trailerDriverDeliveringSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getTrucks () {
      var trucksSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'truck')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/5')
        .then(response => {
          var trucks = response.data
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              trucksSelect.values.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getTrailers () {
      var trailersSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'trailer')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/8')
        .then(response => {
          var trailers = response.data
          for (var i = 0; i < trailers.length; i++) {
            if (!trailers[i].data.inActive) {
              trailersSelect.values.push({'id': trailers[i].id, 'name': trailers[i].data.regnbr})
            }
          }
        })
        .catch(error => console.log(error))
    },
    checkPermission (driver) {
      let loadingPlace = this.order.data.loadingPlaces
      let deliveryPlace = this.order.data.deliveryPlaces
      if ((loadingPlace === 'Kemira' && driver.permissionLoadAcidFromKemira !== 'Ja') ||
      (loadingPlace === 'Inovyn' && driver.permissionLoadAcidFromInovyn !== 'Ja') ||
      (loadingPlace === 'Vetlanda' && driver.permissionLoadProductFromVet !== 'Ja') ||
      (loadingPlace === 'Sölvesborg' && this.order.data.productId === 'SOL-P-FeCl3 314' && driver.permissionLoadProdFrSolE90 !== 'Ja')) {
        this.showNoPermission()
      }
      if ((deliveryPlace === 'Vetlanda' && driver.permissionUnloadProductInVet !== 'Ja') || (deliveryPlace === 'Sölvesborg' && driver.permissionUnloadProductInSol !== 'Ja')) {
        this.showNoPermission()
      }
    },
    showNoPermission () {
      this.toastPosition = 'center'
      this.$toast.add({severity: 'warn', summary: 'Vald chaufför har inte rätt behörighet', life: 3000000})
    },
    onCopy () {
      let message = 'Vill du kopiera ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var copyOrder = Object.assign({}, this.order)
          let data = copyOrder.data
          delete data['orderRows']
          delete data['accepted']
          delete data['GroupLoading']
          delete data['connectedOrder']
          copyOrder.data.fraktsedelNr = ''
          var url = '/api/orders'
          this.$http
            .post(url, {
              order: {
                type: 'feralcoIntern',
                state: 'kopierad',
                needsAttention: 0,
                data: this._.omit(data, 'submit')
              }
            })
            .then(response => {
              this.$router.push({ name: 'FeralcoInternOrderDetails', params: { id: response.data.id } })
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onSave () {
      var url = '/api/orders/' + this.order.id
      if (this.order.state === 'avslutad') {
        this.order.state = 'avslutad'
      } else if (this.order.state === 'accepterad') {
        this.order.state = 'accepterad'
      } else if (this.order.state === 'lastad') {
        this.order.state = 'lastad'
      } else if (this.order.state === 'kopierad') {
        this.order.state = 'redo'
      } else if (this.order.state === 'sparad') {
        this.order.state = 'sparad'
      } else if (this.order.state === 'aktiv') {
        this.order.state = 'aktiv'
      } else if (this.order.state === 'skickad') {
        this.order.state = 'skickad'
      } else {
        this.order.state = 'uppdaterad'
      }
      this.order.data.dateDelivery = new Date(Date.UTC(this.order.data.dateDelivery.getFullYear(), this.order.data.dateDelivery.getMonth(), this.order.data.dateDelivery.getDate()))
      this.order.data.dateBooking = new Date(Date.UTC(this.order.data.dateBooking.getFullYear(), this.order.data.dateBooking.getMonth(), this.order.data.dateBooking.getDate()))
      this.order.data.quantity = this.order.data.quantity.replace(',', '.')
      this.$http
        .put(url, {
          order: {
            id: this.order.id,
            state: this.order.state,
            data: this._.omit(this.order.data, 'submit')
          }
        })
        .then(response => {
          this.toastPosition = 'topright'
          this.$toast.add({severity: 'success', summary: 'Order sparad', life: 3000})
          // Saves connected order
          if (this.order.data.connectedOrder !== null && this.order.data.GroupLoading !== null && this.order.data.GroupLoading !== undefined) {
            if (this.order.data.GroupLoading.toString().startsWith('HAGENSINTERN')) {
              let connectedOrder = this.connectedOrders.find(x => x.id === this.order.data.connectedOrder.id)
              connectedOrder.data.GroupLoading = this.order.data.GroupLoading
              let connectedUrl = '/api/orders/' + this.order.data.connectedOrder.id
              this.$http
                .put(connectedUrl, {
                  order: {
                    id: connectedOrder.id,
                    state: connectedOrder.state,
                    data: connectedOrder.data
                  }
                })
                .then(response => {})
                .catch(error => console.log(error))
            }
          }
        })
        .catch(error => console.log(error))
    },
    onReady () {
      var url = '/api/orders/' + this.order.id
      if (this.order.data.driverLoading && this.order.data.truck) {
        if (this.order.state === 'avslutad') {
          this.order.state = 'avslutad'
        } else if (this.order.state === 'accepterad') {
          this.order.state = 'accepterad'
        } else if (this.order.state === 'lastad') {
          this.order.state = 'lastad'
        } else if (this.order.state === 'sparad') {
          this.order.state = 'sparad'
        } else if (this.order.state === 'aktiv') {
          this.order.state = 'aktiv'
        } else {
          this.order.state = 'skickad'
        }
        this.order.data.dateDelivery = new Date(Date.UTC(this.order.data.dateDelivery.getFullYear(), this.order.data.dateDelivery.getMonth(), this.order.data.dateDelivery.getDate()))
        this.order.data.dateBooking = new Date(Date.UTC(this.order.data.dateBooking.getFullYear(), this.order.data.dateBooking.getMonth(), this.order.data.dateBooking.getDate()))
        this.order.data.quantity = this.order.data.quantity.replace(',', '.')
        this.$http
          .put(url, {
            order: {
              id: this.order.id,
              state: this.order.state,
              data: this._.omit(this.order.data, 'submit')
            }
          })
          .then(response => {
            this.toastPosition = 'topright'
            this.$toast.add({severity: 'success', summary: 'Order sparad och skickad till lastbil', life: 3000})
            // Saves connected order
            if (this.order.data.connectedOrder !== null && this.order.data.GroupLoading.toString().startsWith('HAGENSINTERN')) {
              let connectedOrder = this.connectedOrders.find(x => x.id === this.order.data.connectedOrder.id)
              connectedOrder.data.GroupLoading = this.order.data.GroupLoading
              let connectedUrl = '/api/orders/' + this.order.data.connectedOrder.id
              this.$http
                .put(connectedUrl, {
                  order: {
                    id: connectedOrder.id,
                    state: connectedOrder.state,
                    data: connectedOrder.data
                  }
                })
                .then(response => {})
                .catch(error => console.log(error))
            }
          })
          .catch(error => console.log(error))
      } else {
        this.toastPosition = 'topright'
        this.$toast.add({severity: 'warn', summary: 'Ordern är inte klar att skickas', life: 3000})
      }
    },
    onActivate () {
      this.order.state = 'aktiv'
      var url = '/api/orders/' + this.order.id
      this.$http
        .put(url, {
          order: {
            id: this.order.id,
            state: 'aktiv',
            data: this._.omit(this.order.data, 'submit')
          }
        })
        .then(response => {
          this.toastPosition = 'topright'
          this.$toast.add({severity: 'success', summary: 'Order satt som aktiv', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onDelete () {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/orders/' + this.order.id
          this.$http
            .put(url, {
              order: {
                id: this.order.id,
                state: 'makulerad',
                data: this._.omit(this.order.data, 'submit')
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onCancel () {
      this.$router.go(-1)
    },
    onFinished () {
      let message = 'Vill du avsluta ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.state = 'avslutad'
          var url = '/api/orders/' + this.order.id
          this.$http
            .put(url, {
              order: {
                state: 'avslutad',
                data: this._.omit(this.order.data, 'submit')
              }
            })
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Order satt som avslutad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onReadyForInvoice (order) {
      let message = 'Vill du sätta ordern redo för fakturering?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.state = 'fakturaredo'
          var url = '/api/orders/' + order.id
          this.$http
            .put(url, {
              order: {
                id: order.id,
                state: 'fakturaredo',
                data: this._.omit(order.data, 'submit')
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/FeralcoInternOrderDetails.vue